<template>
  <div>
    <i-text-field
      ref="file"
      v-model="fileName"
      :label="label"
      single-line
      readonly
      :rules="isReadonly ? [() => true] : rules"
      outlined
      hide-details="auto"
      @click="fileEvent"
      validate-on-blur
      dense
    ></i-text-field>
    <div class="btn-post" v-if="!isReadonly">
      <i-btn
        v-if="fileId"
        elevation="0"
        color="normal"
        class="mr-2"
        outlined
        small
        @click="deleteFile"
        >파일 삭제</i-btn
      >
      <i-btn elevation="0" color="normal" outlined small @click="open">
        <template v-if="fileId">{{ $t('파일 수정') }}</template>
        <template v-else>{{ $t('파일 추가') }}</template>
      </i-btn>
    </div>
    <v-file-input
      ref="file"
      v-model="file"
      prepend-icon=""
      hide-input
      @change="uploadFile"
    ></v-file-input>
  </div>
</template>
<script>
import {
  getMultipart,
  postMultipart,
  getAuthJson,
  postAuthJson,
} from '@/api/network';
import { DialogMixin } from '@/mixin/dialog.js';
import { LoadingMixin } from '@/mixin/loading.js';

export default {
  mixins: [DialogMixin, LoadingMixin],
  props: {
    label: { type: String },
    bucketType: { type: String },
    sectionKey: { type: String },
    rules: {
      type: Array,
      default: () => [() => true],
    },
    existingFileId: { type: [String, Number] },
    maxSize: {
      type: Number,
      default: function() {
        return 2;
      },
    },
    limitExtList: {
      type: Array,
      default: function() {
        return [];
      },
    },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },
  data: () => ({
    file: null,
    fileId: null,
    fileName: '',
  }),
  mounted() {
    this.injectParentValidator();
    if (this.existingFileId && this.existingFileId != '') {
      this.getFile();
    } else {
      this.file = null;
      this.fileId = null;
      this.fileName = '';
    }
  },
  methods: {
    injectParentValidator() {
      // v-form 이 parent 인 경우  , 1depth 만 검사
      if (this.$parent.$el instanceof HTMLFormElement) {
        this.$parent.register?.(this.$refs.file);
      }
    },
    initFiles() {
      this.file = null;
      this.fileId = null;
      this.fileName = '';
    },
    open: function() {
      this.$refs.file.$el.querySelector('input[type="file"]').click();
    },
    getFile() {
      this.existingFileId &&
        getAuthJson(
          'api/v1/' + this.$route.params.tenantKey + '/cv/file/info',
          {
            fileId: +this.existingFileId,
          },
        )
          .then(res => {
            if (res && res.data) {
              this.fileName = res.data.fileName;
              this.fileId = res.data.fileId;
            }
          })
          .then(res => {
            if (res && res.data) {
              this.fileName = res.data.fileName;
              this.fileId = res.data.fileId;
            }
          })
          .catch(error => {
            console.log(error.response);
          });
    },
    fileEvent: function() {
      if (this.fileId) {
        this.downloadFile();
      } else if (!this.isReadonly) {
        this.open();
      }
    },
    validFile: function() {
      if (this.file.size == 0) {
        this.$showAlert('파일 사이즈가 0입니다. 파일을 다시 확인해주세요.');
        return false;
      } else {
        var mbyte = this.file.size / (1024 * 1024);
        if (mbyte > this.maxSize) {
          this.$showAlert('파일 허용 크기를 초과했습니다.');
          return false;
        }
      }

      if (
        this.limitExtList &&
        Array.isArray(this.limitExtList) &&
        this.limitExtList.length > 0
      ) {
        var extension = this.file.name.substring(
          this.file.name.lastIndexOf('.') + 1,
        );
        if (this.limitExtList.indexOf(extension) < 0) return false;
      }

      return true;
    },
    async uploadFile() {
      if (this.file && this.validFile()) {
        this.$showLoading();
        const tenantKey = this.$route.params.tenantKey;

        const formData = new FormData();
        formData.append('annoId', this.$route.params.annoId);
        formData.append('bucketType', this.bucketType); //임시 폴더에 저장할 경우 bucketType은 'temp', 업로드 폴더에 바로 저장할 경우 ''
        formData.append('sectionKey', this.sectionKey);
        formData.append('file', this.file, this.file.name);

        if (this.existingFileId) {
          formData.append('existingFileId', this.existingFileId); //기존 파일이 있는 경우 기존 파일의 fileId 넘겨줘야 함
        }

        await postMultipart('api/v1/' + tenantKey + '/cv/file', formData)
          .then(response => {
            let v;
            let data = response.data;

            if (
              data != null &&
              data != undefined &&
              data.hasOwnProperty('fileId')
            ) {
              v = {
                message: '업로드되었습니다.',
                title: '',
                callback: this.uploadCallback,
              };
              this.fileName = this.file.name;
              this.fileId = data.fileId;
            } else {
              v = {
                message:
                  '파일이 정상적으로 업로드 되지 않았습니다.\n다시 한 번 업로드 하시기 바랍니다.',
                title: '',
                callback: '',
              };
            }
            this.$hideLoading();
            this.$showAlert(v);
          })
          .catch(error => {
            console.log('FAILURE!!');
            console.log(error);
          });
      }
    },
    uploadCallback() {
      this.hideLoading();
      this.$emit('upload', this.sectionKey, this.fileId);
    },
    downloadFile() {
      this.showLoading();

      const p = {
        annoId: this.$route.params.annoId,
      };

      getMultipart(
        'api/v1/' + this.$route.params.tenantKey + '/cv/file/' + this.fileId,
        p,
      )
        .then(res => {
          let blob = new Blob([res.data], {
            type: res.headers['content-type'],
          });
          let fileName = this.fileName;
          fileName = decodeURI(fileName); // 파일명 디코딩 (프로젝트에 따라 사용여부 옵션)

          this.hideLoading();

          if (window.navigator.msSaveOrOpenBlob) {
            // IE 10+
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            // not IE
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.target = '_self';
            if (fileName) link.download = fileName;
            link.click();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    deleteFile() {
      this.showLoading();

      const p = {
        annoId: this.$route.params.annoId,
      };

      postAuthJson(
        'api/v1/' + this.$route.params.tenantKey + '/cv/file/' + this.fileId,
        p,
      )
        .then(res => {
          this.hideLoading();
          if (res.status == 200) {
            let v = {
              message: '삭제되었습니다.',
              title: '',
              callback: this.deleteCallback,
            };
            this.$showAlert(v);
          }
        })
        .catch(error => {
          console.log(error.response);
        });
    },
    deleteCallback() {
      this.hideLoading();
      this.initFiles();
      this.$emit('delete', this.sectionKey);
    },
  },
};
</script>
